export default __webpack_public_path__ + "maps-examples-shape-collection-thumbnail-480-b99b3f5dbd049358c1db7840df5b475d.webp";